var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.44,
    y1: 170.16,
    x2: 156.78,
    y2: 52.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.7,151.49s104.44,40.17,89.65-103.18C160.35,48.31,19,51.13,70.7,151.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.75,
    y1: 77.49,
    x2: 113.67,
    y2: 101.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.02,
    y1: 92.02,
    x2: 144,
    y2: 98.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.82,
    y1: 123.03,
    x2: 116.79,
    y2: 129.43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/LEAF.82611d3ef5abb6c86ca0699ce2cdf627.svg";
export { ForwardRef as ReactComponent };